import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { App } from '@app/App';
import { store } from '@app/store';
import { dropLegacyAccessToken } from '@app/utils';

dropLegacyAccessToken();

const container = document.getElementById('root') as HTMLElement;

let root: ReactDOM.Root | null = null;

const getRoot = () => {
  if (!root) {
    root = ReactDOM.createRoot(container);
  }
  return root;
};

getRoot().render(
  <Provider store={store}>
    <App />
  </Provider>
);

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
}
